var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapSingleDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41923",
    "data-name": "Group 41923",
    transform: "translate(17328 -2462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15797",
    "data-name": "Rectangle 15797",
    width: 32,
    height: 32,
    transform: "translate(-17328 2462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41921",
    "data-name": "Group 41921",
    transform: "translate(-32 -79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M103.652-484.214h-11v-2h11v2",
    transform: "translate(-17388.652 3045.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-2",
    "data-name": "path64",
    d: "M103.652-484.214h-11v-2h11v2",
    transform: "translate(-17367.652 3045.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M453.518-681.808h-.5v-8h.5v8",
    transform: "translate(-18087.943 2720.436) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37119",
    "data-name": "Path 37119",
    d: "M-17275,2559.01a5.694,5.694,0,0,0-4.672-5.87",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapSingleDoor);
export default __webpack_public_path__ + "static/media/agent-map-single-door.d49cc3d2e23e65b8b2270f1368d60a60.svg";
export { ForwardRef as ReactComponent };